import { AfterViewInit, Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { InputConverter } from '../../../inputConverter';
import { ExportService } from '../../../services/export.service';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-export-layer',
    templateUrl: './export-layer.component.html',
    styleUrls: ['../../sharedStyles/base.scss', './export-layer.component.scss']
})
export class ExportLayerComponent extends BaseComponent implements AfterViewInit {
    @Input() @InputConverter() layerId: number;
    constructor(_vcr: ViewContainerRef, private readonly exportService: ExportService) { super(_vcr, true); }

    ngAfterViewInit() {
        this.isReady();
    }

    @Input() get ExportService() {
        return this.exportService;
    }

    async exportToShapeFileAndOpenUrl() {
        const exportParams = { layerId: this.layerId };
        await this.exportService.exportToShapeFileAndOpenUrl(exportParams);
    }

}
